import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-727b34f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload_box" }
const _hoisted_2 = {
  key: 0,
  class: "hover_box"
}
const _hoisted_3 = { class: "img_box" }
const _hoisted_4 = { class: "img_hover" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "up_text"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "上传照片", -1))
const _hoisted_9 = [
  _hoisted_8
]

import { message, Upload } from 'ant-design-vue';
import { getToken } from '@/plugins/cookie';
import { withDefaults } from 'vue';
import { PlusOutlined, LoadingOutlined, DeleteOutlined } from '@ant-design/icons-vue';
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface Props {
  fileList: any;
  name?: any;
  listType?: any;
  showList?: boolean;

  accept?: string;
  action?: string;
  headers?: any;
  beforeUpload?: (...args: any[]) => any;
  handleChange: (...args: any[]) => any;
  loading?: boolean;
  imageName?: string;
  clickStop?: (...args: any[]) => any;
  mask?: boolean;
  plus?: boolean;
  uploadText?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CUploads',
  props: {
    fileList: { default: [] },
    name: { default: 'images' },
    listType: { default: 'picture-card' },
    showList: { type: Boolean, default: false },
    accept: null,
    action: null,
    headers: null,
    beforeUpload: null,
    handleChange: null,
    loading: { type: Boolean, default: false },
    imageName: { default: '' },
    clickStop: null,
    mask: { type: Boolean, default: true },
    plus: { type: Boolean, default: true },
    uploadText: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { fileList: any, name: any, listType: any, showList: boolean, accept?: string, action?: string, headers?: any, beforeUpload?: (...args: any[]) => any, handleChange: (...args: any[]) => any, loading: boolean, imageName: string, clickStop?: (...args: any[]) => any, mask: boolean, plus: boolean, uploadText: boolean };

const aUpload = Upload;
const token = getToken();
const beforeUpload = (file: FileItem) => {
  const isJpgOrPng = file.type === 'image/gif';
  if (!isJpgOrPng) {
    message.error('上传图片的格式有误!');
  }
  return isJpgOrPng;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aUpload), {
      "v-model:file-list": props.fileList,
      name: props.name,
      "show-upload-list": props.showList,
      accept: ".gif",
      action: "/api/v1/common/upload_images",
      headers: { token: _unref(token) },
      "before-upload": beforeUpload,
      onChange: props.handleChange,
      class: "ant_upload"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (props.imageName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(PlusOutlined), { class: "CIon" }),
                    _createVNode(_unref(DeleteOutlined), {
                      id: "disable",
                      onClick: _withModifiers(__props.clickStop, ["stop"])
                    }, null, 8, ["onClick"])
                  ])
                ], 512), [
                  [_vShow, props.mask]
                ]),
                _renderSlot(_ctx.$slots, "image", {}, () => [
                  (props.imageName)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "upload_img",
                        src: props.imageName
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (props.loading)
                  ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _withDirectives(_createVNode(_unref(PlusOutlined), null, null, 512), [
                        [_vShow, props.plus]
                      ]),
                      _renderSlot(_ctx.$slots, "uploadImg", {}, () => [
                        _withDirectives(_createElementVNode("div", null, _hoisted_9, 512), [
                          [_vShow, props.uploadText]
                        ])
                      ])
                    ]))
              ]))
        ])
      ]),
      _: 3
    }, 8, ["v-model:file-list", "name", "show-upload-list", "headers", "onChange"])
  ]))
}
}

})